import { parseNotes } from './notesFormat';

export function NotePreview({ notes }: { notes: string | null | undefined }) {
  const entry = parseNotes(notes)[0];
  const text = (entry?.blocks ?? [])
    .map((b) => (b.kind === 'rule' ? '' : b.kind === 'field' ? `${b.label}: ${b.text}` : b.text))
    .filter(Boolean)
    .join(' · ');
  if (!entry || !text) return null;
  return (
    <div className="note-preview" role="note" aria-label="Letzte Notiz">
      <p className="muted small">{entry.when ? `Letzte Notiz · ${[entry.author, entry.when].filter(Boolean).join(' · ')}` : 'Notiz (früher, z. B. aus Dialfire)'}</p>
      <p className="note-preview-text">{text}</p>
      <button type="button" className="link-button small" onClick={() => document.getElementById('notizen')?.scrollIntoView?.({ behavior: 'smooth' })}>
        Alle Notizen
      </button>
    </div>
  );
}
